import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useScopedAppFlagStore } from '@frontend/scope';

export const useGetAppointmentColorsEnabled = () => {
  const { isIntegratedOffice } = DataSourcesQueries.useGetAccessibleIntegrations();

  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const isAppointmentColorsEnabled = getFeatureFlagValue('schedule-appointment-colors');

  const canUseAppointmentColors = isAppointmentColorsEnabled && !isIntegratedOffice;

  return { canUseAppointmentColors };
};
